import _ from 'lodash';

export const HtmlUtil = {
	encodeUri: (value: string) => {
		value = encodeURIComponent(value);
		return _.replace(value, /%/g, '{~}');
	},
};
